import { gql } from '@apollo/client';
import { DiscountInfo } from '../fragments';

export default gql`
  query discount($id: ID!) {
    discount(id: $id) {
      ...DiscountInfo
    }
  }
  ${DiscountInfo}
`;
